module.exports = __webpack_public_path__ + "img/experience-1.ddd34837.jpeg";